import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaPhone, FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <h3>Bromeli Kertészet</h3>
          <p>
            Kertészeti tanácsadó blog, amely segít fenntartható és szép kertet
            kialakítani otthonában. Szakértői ismeretek, gyakorlati tippek és
            inspiráció minden évszakban.
          </p>
          <p style={{ marginTop: "15px" }}>
            <FaPhone style={{ marginRight: "8px" }} /> +36707470117
            <br />
            <FaEnvelope style={{ marginRight: "8px" }} />{" "}
            <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a>
            <br />
            <FaHome style={{ marginRight: "8px" }} /> 0535 Budapest, Szilágyi
            udvar 9. 80. emelet, Magyarország
          </p>
        </div>
        <div className="footer-links">
          <h3>Gyors navigáció</h3>
          <Link to="/">Főoldal</Link>
          <Link to="/about">Rólunk</Link>
          <Link to="/contact">Kapcsolat</Link>
          <Link to="/post/1">Legújabb bejegyzés</Link>
        </div>
        <div className="footer-links">
          <h3>Jogi nyilatkozatok</h3>
          <Link to="/privacy-policy">Adatvédelmi irányelvek</Link>
          <Link to="/terms-conditions">Felhasználási feltételek</Link>
          <Link to="/refund-policy">Visszatérítési szabályzat</Link>
          <p style={{ marginTop: "10px", fontSize: "0.85rem" }}>
            Regisztrációs szám: 40740896
          </p>
        </div>
        <div className="footer-links">
          <h3>Közösségi média</h3>
          <a href="https://wa.me/36707470117">WhatsApp</a>
          <a href="https://viber.me/36707470117">Viber</a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          © 2026 Bromeli Kertészet. Minden jog fenntartva. |{" "}
          <Link to="/privacy-policy">Adatvédelem</Link> |{" "}
          <Link to="/terms-conditions">Feltételek</Link> |{" "}
          <Link to="/refund-policy">Visszatérítés</Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
